import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "clearListBtn", "optionBtn",
                    "mineBtn", "othersBtn"]

  connect() {
    this.controllerName = `users--works--activities--tickets--list`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.tableCols = 8
    this.sort = { mode: `desc`, field: `due_at_to_time` }
    this.hasShow = false
    this.kindTicket = `mine`
  }

  showTicket(ev) {
    var ticketId = ev.target.closest(".itemRow").dataset.id
    var currentTicket = {}

    this.application.tickets.forEach(element => {
      if (element.id == ticketId) {
        currentTicket = element
      }
    })

    var controllerModal = `users--works--activities--shared--show-modal`

    var html = `<div class="modal fade" data-controller="${controllerModal}" data-${controllerModal}-target="modal" id="connectionModal" tabindex="-1" role="dialog" aria-labelledby="connectionModalTitle" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div class="modal-content">
                      <div class="modal-body p-0" data-${controllerModal}-target="body"></div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.getControllerByIdentifier(controllerModal).current_ticket = currentTicket
      controller.getControllerByIdentifier(controllerModal).permission = `user_work_activity_tickets`

      controller.getControllerByIdentifier(controllerModal).open()
    })
  }

  addTicket() {
    this.showClearBtn()

    this.getControllerByIdentifier("users--works--activities--tickets--save").actionMode = "new"
    this.getControllerByIdentifier("users--works--activities--tickets--save").current_ticket = {}
    this.getControllerByIdentifier("users--works--activities--tickets--save").doFormHtml()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  doListHtml() {
    // if (this.application.permissions.user_work_activity_tickets.can_create) {
    //   var addLine = `<span data-action="click->${this.controllerName}#addTicket" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Ticket</span>`
    // } else {
    //   var addLine = ``
    // }
    var mineBtn = `<span class="badge badge-secondary-primary mx-2 pointer" data-action="click->${this.controllerName}#setTicketsEv" data-${this.controllerName}-target="mineBtn" data-kind-ticket="mine">Meus Tickets</span>`
    var othersBtn = `<span class="badge badge-secondary-danger mx-2 pointer" data-action="click->${this.controllerName}#setTicketsEv" data-${this.controllerName}-target="othersBtn" data-kind-ticket="others">De Outros</span>`

    var addLine = ``

    var refreshLine = `<span data-action="click->${this.controllerName}#refreshTickets" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Tickets</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    // filter_list
    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${refreshLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`

    var html = `<div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 card-title-table-list">Todos os Tickets | ${mineBtn} | ${othersBtn}</h6>
                    <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                    <div class="card-actions ml-auto py-0">
                      ${clearBtnHtml}
                      ${submenuHtml}
                    </div>
                  </div>
                  <div class="card-body py-0" style="overflow:auto;">
                    <div class="row">
                      <div class="col p-0">
                        <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                          <thead>
                            <tr>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">Data</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-30 align-middle">Descrição</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Dono</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Executor</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Prioridade</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle text-center">Tempo</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle text-center">Domínio</th>
                              <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle text-center"></th>
                            </tr>
                          </thead>
                          <tbody data-${this.controllerName}-target="bodyTable">
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`users--works--activities--tickets--dashboard`).mainTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.65) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.setTickets()
    })
  }

  setTicketsEv(ev) {
    this.kindTicket = ev.currentTarget.dataset.kindTicket

    this.setTickets()
  }

  setTickets() {
    if (this.kindTicket == `mine`) {
      this.kind_ticket_pretty = `Meus Tickets`
      this.mineBtnTarget.classList.remove(`badge-secondary-primary`)
      this.mineBtnTarget.classList.add(`badge-primary`)
      this.othersBtnTarget.classList.add(`badge-secondary-danger`)
      this.othersBtnTarget.classList.remove(`badge-danger`)
    } else if (this.kindTicket == `others`) {
      this.kind_ticket_pretty = `De Outros`
      this.mineBtnTarget.classList.add(`badge-secondary-primary`)
      this.mineBtnTarget.classList.remove(`badge-primary`)
      this.othersBtnTarget.classList.remove(`badge-secondary-danger`)
      this.othersBtnTarget.classList.add(`badge-danger`)
    }

    this.doDataTable()
  }

  doDataTable() {
    // var current_tickets = this.application.filter_tickets
    
    
    var current_tickets = []
    if (this.kindTicket == `mine`) {
      this.application.filter_tickets.forEach(element => {
        if (element.performer_id == this.application.current_user.account_id) {
          current_tickets[current_tickets.length] = element
        }
      })
    } else if (this.kindTicket == `others`) {
      this.application.filter_tickets.forEach(element => {
        if (element.performer_id != this.application.current_user.account_id) {
          current_tickets[current_tickets.length] = element
        }
      })
    }

    if (this.sort.mode == `asc`) {
      var tickets = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_tickets, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var tickets = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_tickets, this.sort.field)
    }

    if (tickets.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(tickets.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (tickets[x] !== undefined) {
            internPage[internPage.length] = tickets[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: tickets.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Tickets</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.ticketTablePartial(element, data.length))
      });
    }
  }

  ticketTablePartial(element, length) {

    if (element.status == `active`) {
      var status = `<span class="mc-tooltip"><span class="material-icons md-sm md-success default">done</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    } else if (element.status == `inactive`) {
      var status = `<span class="mc-tooltip"><span class="material-icons md-sm md-danger default">clear</span><span class="mc-tooltiptext">${element.status_pretty}</span></span>`
    }

    if (element.total_comments > 0) {
      var commentBadge = `<span class="badge badge-danger notice-badge notice-badge-sm" data-${this.controllerName}-target="totalComments-${element.id}">${element.total_comments}</span>`
    } else {
      var commentBadge = `<span class="badge badge-danger notice-badge notice-badge-sm d-none" data-${this.controllerName}-target="totalComments-${element.id}">${element.total_comments}</span>`
    }
    
    var comment = `<span class="mc-tooltip">
                      <span class="material-icons md-dark">comment</span>
                      ${commentBadge}
                      <span class="mc-tooltiptext">Comentários</span>
                    </span>`
    
    if (element.priority == `low`) {
      var priority = `<span class="mc-tooltip"><span class="material-icons md-sm md-success">grade</span><span class="mc-tooltiptext">${element.priority_pretty}</span></span>`
    } else if (element.priority == `medium`) {
      var priority = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-yellow2">grade</span>
                        <span class="material-icons md-sm md-yellow2">grade</span>
                        <span class="mc-tooltiptext">${element.priority_pretty}</span>
                      </span>`
    } else if (element.priority == `high`) {
      var priority = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-orange2">grade</span>
                        <span class="material-icons md-sm md-orange2">grade</span>
                        <span class="material-icons md-sm md-orange2">grade</span>
                        <span class="mc-tooltiptext">${element.priority_pretty}</span>
                      </span>`
    } else if (element.priority == `maximum`) {
      var priority = `<span class="mc-tooltip">
                        <span class="material-icons md-sm md-red2">grade</span>
                        <span class="material-icons md-sm md-red2">grade</span>
                        <span class="material-icons md-sm md-red2">grade</span>
                        <span class="material-icons md-sm md-red2">grade</span>
                        <span class="mc-tooltiptext">${element.priority_pretty}</span>
                      </span>`
    }

    if (element.term == "quick") {
      var mdIcon = `filter_1`
      var mdClass = `md-blue`
    } else if (element.term == "normal") {
      var mdIcon = `filter_3`
      var mdClass = `md-dark`
    } else if (element.term == "long") {
      var mdIcon = `filter_5`
      var mdClass = `md-warning`
    } else if (element.term == "large") {
      var mdIcon = `filter_9_plus`
      var mdClass = `md-danger`
    }

    var term = `<span class="mc-tooltip">
                  <span class="material-icons md-150 ${mdClass} pointer">${mdIcon}</span>
                  <span class="mc-tooltiptext">${element.term_pretty}</span>
                </span>`

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-path="${element.board_path}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" data-path="${element.board_path}">`
    }

    var rowHtml = `${tableRow}
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showTicket">${element.due_at_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle pointer" data-action="click->${this.controllerName}#showTicket">${element.body}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#showTicket">${element.owner_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#showTicket">${element.performer_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#showTicket">${priority}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#showTicket">${term}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#goToDomain">
                      <span class="mb-0 f-065 mc-tooltip">
                        <span>${element.board_name}</span>
                        <span class="mc-tooltiptext">Ver Domínio</span>
                      </span>
                    </td>
                    <td style="font-size:100%;" scope="col" class="p-1 align-middle text-center pointer" data-action="click->${this.controllerName}#showTicket">${comment}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  showClearBtn() {
    this.clearListBtnTarget.classList.remove(`d-none`)
    this.optionBtnTarget.classList.add(`d-none`)
  }

  clearList() {
    this.clearListBtnTarget.classList.add(`d-none`)
    this.optionBtnTarget.classList.remove(`d-none`)

    this.getControllerByIdentifier("users--works--activities--tickets--show").doViewHtml()
    this.getControllerByIdentifier("users--works--activities--tickets--save").stopRefreshing()
    this.doDataTable()
  }

  refreshTickets() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()

    const data = { ticket: { performer_id: this.application.account_id }, current_user: { current_user_id: this.application.current_user.id, feature: `user_work_activity_tickets` } }
    const url = "/users/works/activities/tickets/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this

    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.tickets = []
        controller.application.all_tickets = response.data.cln

        if (controller.application.account_id == controller.application.current_user.account_id) {
          controller.application.tickets = controller.application.all_tickets
        } else {
          controller.application.all_tickets.forEach(element => {
            if (controller.application.current_squad.board_types.includes(element.board_type)) {
              controller.application.tickets[controller.application.tickets.length] = element
            }
          })
        }

        controller.application.uniq_board_ids = controller.mapElements(controller.application.tickets, `board_id`).filter(controller.onlyUnique)
        controller.application.uniq_board_types = controller.mapElements(controller.application.tickets, `board_type`).filter(controller.onlyUnique)
        controller.application.uniq_board_types_pretty = controller.mapElements(controller.application.tickets, `board_type_pretty`).filter(controller.onlyUnique)
        controller.application.uniq_board_names = controller.mapElements(controller.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(controller.application.tickets, `board_name`), `board_name`).filter(controller.onlyUnique)
        controller.application.uniq_owner_ids = controller.mapElements(controller.application.tickets, `owner_id`).filter(controller.onlyUnique)
        controller.application.uniq_owner_names = controller.mapElements(controller.application.tickets, `owner_name`).filter(controller.onlyUnique)
        controller.application.uniq_performer_ids = controller.mapElements(controller.application.tickets, `performer_id`).filter(controller.onlyUnique)
        controller.application.uniq_performer_names = controller.mapElements(controller.application.tickets, `performer_name`).filter(controller.onlyUnique)
        controller.application.uniq_filters = controller.mapElements(controller.application.tickets, `filters`).filter(controller.onlyUnique)

        controller.application.filter_tickets = controller.application.tickets

        controller.getControllerByIdentifier(`users--works--activities--tickets--filter`).doFilterHeader()
        // controller.getControllerByIdentifier(`users--works--activities--tickets--board`).doBoardGrid()
        controller.getControllerByIdentifier(`users--works--activities--tickets--list`).doListHtml()

        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToDomain(ev) {
    var url = ev.currentTarget.closest(`.itemRow`).dataset.path
    window.open(url, `_blank`)
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    })
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
